"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var lib_exports = {};
__export(lib_exports, {
  Lib: () => Lib
});
module.exports = __toCommonJS(lib_exports);
var import_basket = require("./lib/basket");
var import_catalog = require("./lib/catalog");
var import_checkout = require("./lib/checkout");
var import_customer = require("./lib/customer");
var import_general = require("./lib/general");
var import_newsletter = require("./lib/newsletter");
var import_response = require("./lib/response");
var Lib;
((Lib2) => {
  Lib2.Basket = import_basket.Basket;
  Lib2.Catalog = import_catalog.Catalog;
  Lib2.Checkout = import_checkout.Checkout;
  Lib2.Customer = import_customer.Customer;
  Lib2.General = import_general.General;
  Lib2.Newsletter = import_newsletter.Newsletter;
  Lib2.Response = import_response.Response;
})(Lib || (Lib = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Lib
});
